import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { Observable } from 'rxjs';

import { BookingSummaryService } from '../../../interfaces';

@Component({
  selector: 'fin-booking-summary-ancillary',
  templateUrl: './booking-summary-ancillary.component.html',
  styleUrls: ['./booking-summary-ancillary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BookingSummaryAncillaryComponent {
  @HostBinding('class.block')
  @HostBinding('class.ancillaries')
  @HostBinding('class.font-body-1')
  defaultClass = true;
  @Input()
  service$: Observable<BookingSummaryService>;
  @Input()
  title: string;
}
